<template>
    <div>
        <b-card class="standardpage border-none">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="routingnames.icon" class="mr-1"></i>
                        <span>{{ routingnames.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-if="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">

                        <b-row v-if="!showfilter">
                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Code" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="code" :debounce="routingnames.debounce"
                                            placeholder="Code"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!code"
                                                @click="code = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col> -->
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="IATA ( Paste List )" label-for="code" label-cols="12">
                                    <!-- <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <b-form-checkbox-group id="isiata" v-model="isiata" :options="options_isiata"
                                            size="sm" value-field="id" text-field="label" name="radio-options"
                                            class="z-0" style="padding-top: 0.2em">
                                        </b-form-checkbox-group>
                                    </b-input-group> -->
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="code" v-model="code" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste IATA (LGW,MAN,...)" size="sm"
                                            class="h-29" add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="code = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Description" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="description" :debounce="routingnames.debounce"
                                            placeholder="Description"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!description"
                                                @click="description = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="routingnames" :icon="routingnames.icon"
                        :busy="routingnames.busy" :toolbarlibrary="routingnames.toolbarlibrary"
                        :tools="routingnames.tools" :badges="routingnames.badges" :fields="routingnames.fields"
                        :items="routingnames.items" :limit="routingnames.limit" :downloaded="routingnames.downloaded"
                        :page="routingnames.page" @load="routingnames_load" @click="routingnames_click"
                        @changed="routingnames_click('save', $event)" @select="routingnames_select">
                    </d-table>
                </div>
            </div>

            <div v-if="component">
                <component :is="component" :selection="routingnames.selected" :config="cconfig"
                    @discard="routingnames_click('discard')" @go="routingnames_click('go')"></component>
            </div>
            <b-card-footer class="mt-2 ml-1">
                <div class="text-center">
                    <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
                        <i class="fa fa-cogs mr-2"></i>Setup All
                    </b-button>
                </div>
            </b-card-footer>
        </b-card>
    </div>
</template>


<script>
import gql from "graphql-tag";

import RoutingNameEdit from "./Components/Setup_RoutingNameEdit";

export default {
    name: "RoutingNames",
    components: { RoutingNameEdit },
    watch: {
        async code() {
            await this.routingnames_load(0);
        },
        async description() {
            await this.routingnames_load(0);
        },
        async isiata() {
            await this.routingnames_load(0);
        },
    },
    data() {
        return {
            description: null,
            code: [],
            options_isiata: [
                { id: '1', label: 'Yes' },
                { id: '0', label: 'No' },

            ],
            isiata: "1",
            routingnames: {
                title: "Routing Names",
                icon: "fa fa-list",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,
                tools: "go,filter,download,add,edit,deleteconfirm",
                toolbarlibrary: [],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-center w-40px",
                    },
                    {
                        key: "code",
                        label: "Code",
                        sortable: true,
                    },
                    {
                        key: "description",
                        label: "Description",
                        sortable: true,
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [],
                items: [],
                selected: [],
                downloaded: [],
                denied: [],
            },
        };
    },
    async mounted() {
        this.accessdenied();
        await this.routingnames_load();
    },

    methods: {
        accessdenied() {
            this.routingnames.denied = [];
            if (!this.user.permissions.includes("setup_routingnames.admin")) {
                this.routingnames.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("setup_routingnames.admin")) {
                this.routingnames.denied.push("add");
                this.routingnames.denied.push("save");
            }

        },

        async routingnames_load(offset, limit, page) {
            let state = this.routingnames;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                description: this.description,
                code: this.code.length > 0 ? this.code.join(",") : null,
                isiata: this.isiata ? this.isiata == "1" ? true : false : null,
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
                query setup_routingnames(
                  $limit: Int
                  $offset: Int
                  $description: String           
                  $code: String   
                  $isiata: Boolean               
                ) {
                    setup_routingnames(
                    limit: $limit
                    offset: $offset
                    code: $code 
                    description: $description  
                    isiata: $isiata               
                  ) {
                    id                                
                    description
                    code                             
                    rows
                    updated_at
                    updated_by
                  }
                }
              `,
                    variables,
                });

                // USE LOCAL VARIABLE        

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.setup_routingnames
                } else {
                    state.items = response.data.setup_routingnames;
                }

            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async routingnames_click(a, ss) {

            let state = this.routingnames;

            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.routingnames_load(0, 0);
                    break;

                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    break;
                case "go":
                    this.component = null;
                    this.routingnames_load();
                    break;
                case "add":
                case "edit":
                    this.component = "RoutingNameEdit";
                    break;

                case "save":
                    this.saveit(ss);
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;
            }
        },
        async routingnames_select(ss, tools) {

            let state = this.routingnames;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "download"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        async saveit(ss) {

            this.busy = true;

            let variables = { rows: this.cleanit(ss) };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                mutation setup_routingnames_save(
                  $rows: [setup_routingnames_input]             
                ) {
                    setup_routingnames_save(rows: $rows) {
                      id                      
                      description
                      code
                  }
                }
              `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
        async deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                mutation setup_routingnames_delete(
                  $rows: [setup_routingnames_input]
                ) {
                    setup_routingnames_delete(rows: $rows) {
                    id
                  }
                }
              `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.routingnames_load(0);
        },
    },
};
</script>

<style></style>